export const thMeterSensorRegistry = [
    {
        meter_id: 1383,
        meter_name: "Casing / LQF Hall",
        location: "Casing/lqf hall",
        sensors: [
            {
                sensor_id: 138,
                sensor_name: "Temp-Hum Sensor 2",
                temp_range: [22, 27],
                humi_range: [45, 60],
            },
        ],
    },

    {
        meter_id: 1382,
        meter_name: "Watchead Bin Hall",
        location: "Watchead Bin hall",
        sensors: [
            {
                sensor_id: 137,
                sensor_name: "Temp-Hum Sensor",
                temp_range: [22, 27],
                humi_range: [45, 60],
            },
        ],
    },

    {
        meter_id: 1384,
        meter_name: "Inhouse Strapping Hall",
        location: "Inhouse Strapping hall",
        sensors: [
            {
                sensor_id: 139,
                sensor_name: "Temp-Hum Sensor 3",
                temp_range: [22, 27],
                humi_range: [45, 60],
            },
        ],
    },

    {
        meter_id: 1304,
        meter_name: "3rd Floor Server Room",
        location: "Server Room 3rd Floor",
        sensors: [
            {
                sensor_id: 133,
                sensor_name: "Server Room Sensor",
                temp_range: [18, 22],
                humi_range: [40, 55],
            },
        ],
    },

    {
        meter_id: 1412,
        meter_name: "IT Server Room",
        location: "IT Server Room",
        sensors: [
            {
                sensor_id: 145,
                sensor_name: "IT Server Room",
                temp_range: [18, 22],
                humi_range: [40, 55],
            },
        ],
    },

    {
        meter_id: 563,
        meter_name: "Sample Storage",
        location: "Sample Storage",
        sensors: [
            {
                sensor_id: 95,
                sensor_name: "Bio Chemistry Storage",
                temp_range: [6, 10],
                humi_range: [60, 80],
            },
            {
                sensor_id: 92,
                sensor_name: "Bio-Chemistry",
                temp_range: [22, 26],
                humi_range: [45, 60],
            },
            {
                sensor_id: 93,
                sensor_name: "Flow-Cytometry",
                temp_range: [22, 26],
                humi_range: [45, 60],
            },
            {
                sensor_id: 94,
                sensor_name: "Serology",
                temp_range: [22, 26],
                humi_range: [45, 60],
            },
        ],
    },

    {
        meter_id: 555,
        meter_name: "Laboratory Refrigerators",
        location: "Refrigerator",
        sensors: [
            {
                sensor_id: 84,
                sensor_name: "OQG/CT/DP/02",
                temp_range: [-75, -65],
                humi_range: [0, 5],
            },
            {
                sensor_id: 85,
                sensor_name: "OQG/CT/DP/01",
                temp_range: [-75, -65],
                humi_range: [0, 5],
            },
        ],
    },

    {
        meter_id: 552,
        meter_name: "CT Area",
        location: "CT Area",
        sensors: [
            {
                sensor_id: 80,
                sensor_name: "Micro-Biology",
                temp_range: [22, 26],
                humi_range: [45, 60],
            },
            {
                sensor_id: 79,
                sensor_name: "Refrigerator",
                temp_range: [-5, 5],
                humi_range: [0, 10],
            },
            {
                sensor_id: 81,
                sensor_name: "Sample Accession Area",
                temp_range: [22, 26],
                humi_range: [45, 60],
            },
        ],
    },

    {
        meter_id: 554,
        meter_name: "SMAS Room",
        location: "SMAS Room",
        sensors: [
            {
                sensor_id: 83,
                sensor_name: "SMAS Room",
                temp_range: [22, 26],
                humi_range: [45, 60],
            },
        ],
    },
];
